import axios, { AxiosResponse } from 'axios'
import { toast } from 'sonner'

const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL as string, // Replace with your API base URL
  timeout: 5000, // Request timeout in milliseconds
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add a request interceptor
request.interceptors.request.use(
  (config) => {
    // Optionally modify the request config before sending it
    // For example, you can add authentication tokens here
    // const token = localStorage.getItem('token') // Replace with your token retrieval logic
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  (error: Error) => {
    // Handle request errors
    return Promise.reject(error)
  }
)

// Add a response interceptor
request.interceptors.response.use(
  <T>(response: AxiosResponse<T>) => {
    // Handle successful responses
    return response.data
  },
  (error: Error) => {
    // Handle response errors
    toast.error(`Request failed: ${error.message}`)
    return Promise.reject(error)
  }
)

const setToken = (token: string) => {
  request.defaults.headers.common.Authorization = `Bearer ${token}`
}

export default request
export { setToken }
